export default __webpack_public_path__ + "static/media/kantine.d8315356.svg";